
  var _styles = {
  "city-drop-down-card": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginLeft": "0.32rem"
  }
};



  module.exports = _styles;
  